import { createContext, useState, useMemo } from "react";
import { InvestTheRestProvider } from "./investTheRestContext";
import { RegularIncomeProvider } from "./regularIncomeContext";
import { MixAndMatchProvider } from "./mixAndMatchContext";

// Minimal shared context (for flags/navigation)
export const RAContext = createContext({
  doNotCallGetApiWhenBackClicked: false,
  setDoNotCallGetApiWhenBackClicked: () => {},
});

export const RAProvider = ({ children }) => {
  const [doNotCallGetApiWhenBackClicked, setDoNotCallGetApiWhenBackClicked] =
    useState(false);

  const value = useMemo(
    () => ({
      doNotCallGetApiWhenBackClicked,
      setDoNotCallGetApiWhenBackClicked,
    }),
    [doNotCallGetApiWhenBackClicked],
  );

  return (
    <RAContext.Provider value={value}>
      <InvestTheRestProvider>
        <RegularIncomeProvider>
          <MixAndMatchProvider>{children}</MixAndMatchProvider>
        </RegularIncomeProvider>
      </InvestTheRestProvider>
    </RAContext.Provider>
  );
};
